<template>
  <RevCard
    v-if="isLinkValid"
    class="h-full"
    :class="
      isProductCompared ? 'border-action-default-hi' : 'border-transparent'
    "
    :data-cnstrc-item="isRecommendation ? 'recommendation' : undefined"
    :data-cnstrc-item-id="product.product.productId"
    :data-cnstrc-item-name="title"
    :data-cnstrc-item-price="price?.amount"
    :data-cnstrc-item-variation-id="listingPublicId"
    data-qa="productCard"
    data-test="product-card"
    :hoverable="true"
  >
    <ProductCardContent
      :comparison="{
        isComparisonEnabled,
        isComparisonAddProductDisabled,
        isResponsiveComparisonEnabled,
        comparisonProducts,
      }"
      :options="{
        withAddToCart: addToCartListener,
        position,
        withStartingFrom,
        extendedDescription,
        withPaymentAdvertisement,
        tracking,
      }"
      :product="{
        ...product,
        listingId: listingId,
        productType: product.product.productType,
        rawProduct: product.product,
      }"
      @add-to-cart="
        ({ status }) => {
          emit('add-to-cart', { status })
        }
      "
      @link-click="emit('link-click', $event)"
      @toggle-comparison-product="emit('toggle-comparison-product', listingId)"
    />
  </RevCard>
</template>

<script lang="ts" setup>
import { computed, getCurrentInstance } from 'vue'

import { RevCard } from '@ds/components/Card'

import type { ExtraTrackingData } from '../../composables/useProductTracking'
import { isValidProductLink } from '../../helpers/isValidProductLink'
import type { Product } from '../../models/product'

import type { ProductCardProduct } from './ProductCard.types'
import ProductCardContent from './ProductCardContent.vue'

export interface ProductCardProps extends Omit<
  ProductCardProduct,
  'rawProduct'
> {
  product: Product
  position?: number
  withStartingFrom?: boolean
  extendedDescription?: boolean
  withPaymentAdvertisement?: boolean
  tracking?: ExtraTrackingData
  isRecommendation?: boolean
}

const {
  listingId,
  comparisonProducts,
  isComparisonAddProductDisabled = false,
  isResponsiveComparisonEnabled = false,
  extendedDescription = false,
  isRecommendation = false,
  withPaymentAdvertisement = false,
  ...product
} = defineProps<ProductCardProps>()

const emit = defineEmits([
  'add-to-cart',
  'toggle-comparison-product',
  'link-click',
])

const addToCartListener = getCurrentInstance()?.vnode.props?.onAddToCart

const isLinkValid = computed(() => isValidProductLink(product.url))

const isProductCompared = computed(() => {
  return comparisonProducts?.some((p) => p.listingId === listingId) || false
})
</script>
